import { useCallback, useEffect, useState } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';

import { AppRoot } from 'twyne-new.ui';

import Authenticated from '@Components/Authenticated';
import { GlobalProvider } from '@Stores/global';
import { useGlobalAuthStore } from '@Stores/global/auth';
import AppWrapper from 'components/app-layout/Wrapper';
import AdminLayout from 'modules/admin/Layout';
import AuthLayout from 'modules/auth/Layout';
import CmsLayout from 'modules/cms/Layout';
import OfferLayout from 'modules/offer/Layout';
import PathLayout from 'modules/path/Layout';
import ProfileLayout from 'modules/profile/Layout';
import ReportsLayout from 'modules/report/Layout';
import SettingsLayout from 'modules/settings/Layout';
import appStore from 'stores/app';
import { APP_PREFIX } from 'utils/constants';
import history from 'utils/history';

import { useBuilderRedirect } from './modules/cms/views/post/components/builder/hooks/useBuilderRedirect';

const setLoading = value => {
  if (value) {
    document.body.classList.add('loading');
  } else {
    document.body.classList.remove('loading');
  }
}

const AppRedirect = ({ to = '/path' }) => {
  const search = history.location.search || ''
  return <Redirect to={to + search} />
}

const AppSiteLoader = ({ match: { params: { siteId }, url } }) => {
  const [siteReady, setSiteReady] = useState(siteId === appStore.site.id)

  const loadSite = useCallback(async () => {
    setLoading(true)
    const sucess = await appStore.setSiteById(siteId)
    if (!sucess) {
      setLoading(false)
      return setSiteReady(true)
    }
    document.location.reload()
  }, [siteId])

  useEffect(() => {
    if (!siteReady) {
      loadSite()
    }
  }, [loadSite, siteReady])

  if (isNaN(siteId)) {
    const pathname = history.location.pathname.replace(APP_PREFIX, '')
    return <AppRedirect to={pathname} />
  }
  const pathname = history.location.pathname.replace(url, '')

  if (!siteReady) {
    return null
  }

  return <AppRedirect to={pathname} />
}

const AppSwicthSite = ({ children }) => {
  useBuilderRedirect()

  useEffect(() => {
    !appStore.sites.length && appStore.listSites()
  })

  return <Route path='/' render={() => <Switch>
    <Route path={`${APP_PREFIX}/:siteId`} component={AppSiteLoader} />
    {children}
  </Switch>}>
  </Route>
}

const AppAuthenticated = ({ children }) => {
  const { auth: { isAuthenticated } } = useGlobalAuthStore()
  if (!isAuthenticated || !appStore.site)
    return <Redirect to='/auth' />
  return children
}

export default function App() {
  useEffect(() => {
    setLoading(false)
  }, [])

  return <>
    <AppWrapper>
      <Router history={history}>
        <Switch>
          <Route path="/auth" component={AuthLayout} />
          <GlobalProvider>
            <Route path="/" render={() => <AppAuthenticated>
              <AppRoot>
                <Authenticated site={appStore.site}>
                  <Route exact path="/" component={AppRedirect} />
                  <Route exact path={APP_PREFIX} component={AppRedirect} />
                  <AppSwicthSite>
                    <Route path="/admin" component={AdminLayout} />
                    <Route path="/path" component={PathLayout} />
                    <Route path="/reports" component={ReportsLayout} />
                    <Route path="/offer" component={OfferLayout} />
                    <Route path="/cms" component={CmsLayout} />
                    <Route path="/settings" component={SettingsLayout} />
                    <Route path="/profile" component={ProfileLayout} />
                  </AppSwicthSite>
                </Authenticated>
              </AppRoot>
            </AppAuthenticated>
            } />
          </GlobalProvider>
        </Switch>
      </Router>
    </AppWrapper>
  </>
}
